import { createMountBridgeController } from "@/controllers/mount_bridge"

export default createMountBridgeController(
  "mountPurposesCombobox",
  "unmountPurposesCombobox",
)
